import { ReplyOrder } from '@diritto/common/reply/constants';
import { useEpisodeReplyDispatch, useEpisodeReplyState } from 'contexts/EpisodeReplyProvider';
import { ReplyTab } from 'app-components/reply/ReplyTab';
import React, { useCallback } from 'react';
import { ContentBodyPaddingContainer2 } from 'ui-components/layout/containers/ContentBodyCenterContainer';

export const EpisodeReplyTab = ({ className, replyCount }: { className?: string; replyCount: number }) => {
  const { orderBy } = useEpisodeReplyState();
  const { onChangeOrderBy } = useEpisodeReplyDispatch();

  const handleChangeOrderBy = useCallback((key: ReplyOrder) => onChangeOrderBy(key), [onChangeOrderBy]);

  return (
    <ContentBodyPaddingContainer2>
      <ReplyTab className={className} replyCount={replyCount} onChange={handleChangeOrderBy} orderBy={orderBy} />
    </ContentBodyPaddingContainer2>
  );
};
